import { useLayoutEffect, useState } from 'react';

const CSS_VAR = '--app-top-bars-height';

/**
 * Altura do topo fixo (faixas + cabeçalho, .header-sticky) publicada em
 * --app-top-bars-height no <html>, para quem gruda no topo ou rola até uma
 * âncora descontar esse espaço (menu de módulos, Estatísticas, avisos). Quando
 * o topo não está fixo (celular) a variável vale 0px. Devolve uma ref de callback.
 * Mesmo padrão de pages/statistics/components/useStickyHeight.js.
 */
export default function useTopBarsHeight() {
  const [element, setElement] = useState(null);

  useLayoutEffect(() => {
    if (!element) return undefined;
    const root = document.documentElement;
    const measure = () => {
      const sticky = window.getComputedStyle(element).position === 'sticky';
      const height = sticky ? Math.ceil(element.getBoundingClientRect().height) : 0;
      root.style.setProperty(CSS_VAR, `${height}px`);
    };
    measure();
    window.addEventListener('resize', measure);
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    if (observer) observer.observe(element);
    return () => {
      window.removeEventListener('resize', measure);
      if (observer) observer.disconnect();
      root.style.setProperty(CSS_VAR, '0px');
    };
  }, [element]);

  return setElement;
}
